import { Button } from '../../ui/components';

export default function SaveBar({ isDirty, saving, lastSaved, onSave, onDiscard }) {
  const timeAgo = lastSaved
    ? (() => {
        const s = Math.round((Date.now() - lastSaved) / 1000);
        if (s < 60)  return `${s}s ago`;
        if (s < 3600) return `${Math.round(s / 60)}m ago`;
        return `${Math.round(s / 3600)}h ago`;
      })()
    : null;

  return (
    <div className={`adm-savebar ${isDirty ? 'adm-savebar--dirty' : ''}`}>
      <span className="adm-savebar__status">
        {saving  ? 'Saving…'
         : isDirty ? '● Unsaved changes'
         : timeAgo ? `Saved ${timeAgo}`
         : 'All changes saved'}
      </span>
      <div className="adm-savebar__btns">
        <Button
          variant="ghost"
          onClick={onDiscard}
          disabled={!isDirty || saving}
        >
          Discard
        </Button>
        <Button
          variant="success"
          onClick={onSave}
          disabled={!isDirty || saving}
          loading={saving}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
}
